import { LitElement, html, TemplateResult } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FontSizes, FontWeights } from '../../../types/common/types';

/**
 * @summary This component it's used to displays a list of items in a two-column format
 * Also this component have a header part that contains two slots for custom content on the left and right sides
 * @tag GzDoubleColumnDetails
 */
@customElement('gz-double-column-details')
export class GzDoubleColumnDetailsWebComponent extends LitElement {
  @property({ type: Array, attribute: true, reflect: true })
  items: [{ label: string; value: string }];

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="double-column-details">
        ${this.renderCardHeader()}
        <div class="double-column-details-content">${this.renderItems(this.items)}</div>
      </div>
    `;
  }
  private renderCardHeader(): TemplateResult {
    return html`
      <div class="double-column-details-header">
        <slot name="header-content-left"></slot>
        <slot name="header-content-right"></slot>
      </div>
    `;
  }

  private renderItems(items: [{ label: string; value: string }]): TemplateResult {
    return html`
      ${items.map(
        item => html`
          <div class="item">
            <gz-text class="item-label" fontSize="${FontSizes.HEADING_6}">${item.label}</gz-text>
            <gz-text class="item-value" fontWeight="${FontWeights.BOLD}" fontSize="${FontSizes.HEADING_6}"
              >${item.value}</gz-text
            >
          </div>
        `
      )}
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-double-column-details': GzDoubleColumnDetailsWebComponent;
  }
}
